"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FireStoreProfilesManager = void 0;
var tslib_1 = require("tslib");
var firestore_1 = require("firebase/firestore");
var utils_1 = require("../../../utils/utils");
var enums_1 = require("../../../enums");
var constants_1 = require("../../../constants/constants");
var auth_1 = require("firebase/auth");
/**
 * Firestore implementation of the ProfilesManagement interface.
 * Provides methods to create, fetch, and check user profiles in Firestore.
 * @class
 * @implements {ProfilesManagement}
 */
var FireStoreProfilesManager = /** @class */ (function () {
    function FireStoreProfilesManager() {
        this.firestoreService = (0, firestore_1.getFirestore)();
    }
    FireStoreProfilesManager.prototype.userHasProfiles = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var profilesCollectionRef, snapshot;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userId)
                            return [2 /*return*/, false];
                        profilesCollectionRef = (0, firestore_1.collection)((0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId), constants_1.COLLECTIONS.PROFILES);
                        return [4 /*yield*/, (0, firestore_1.getDocs)(profilesCollectionRef)];
                    case 1:
                        snapshot = _a.sent();
                        return [2 /*return*/, !snapshot.empty];
                }
            });
        });
    };
    FireStoreProfilesManager.prototype.createProfile = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var waitForAuth;
            return tslib_1.__generator(this, function (_a) {
                waitForAuth = function () {
                    return new Promise(function (resolve, reject) {
                        var auth = (0, auth_1.getAuth)();
                        var unsubscribe = auth.onAuthStateChanged(function (user) {
                            unsubscribe();
                            if (user) {
                                resolve(user);
                            }
                            else {
                                reject(new Error('No user is logged in'));
                            }
                        });
                    });
                };
                waitForAuth();
                return [2 /*return*/, (0, utils_1.cloudFunction)(enums_1.CloudFunction.CREATE_USER_PROFILE, params)];
            });
        });
    };
    FireStoreProfilesManager.prototype.updateProfile = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var waitForAuth;
            return tslib_1.__generator(this, function (_a) {
                waitForAuth = function () {
                    return new Promise(function (resolve, reject) {
                        var auth = (0, auth_1.getAuth)();
                        var unsubscribe = auth.onAuthStateChanged(function (user) {
                            unsubscribe();
                            if (user) {
                                resolve(user);
                            }
                            else {
                                reject(new Error('No user is logged in'));
                            }
                        });
                    });
                };
                waitForAuth();
                return [2 /*return*/, (0, utils_1.cloudFunction)(enums_1.CloudFunction.UPDATE_USER_PROFILE, params)];
            });
        });
    };
    FireStoreProfilesManager.prototype.getProfiles = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var profilesCollectionRef, snapshot;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        profilesCollectionRef = (0, firestore_1.collection)((0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId), constants_1.COLLECTIONS.PROFILES);
                        return [4 /*yield*/, (0, firestore_1.getDocs)(profilesCollectionRef)];
                    case 1:
                        snapshot = _a.sent();
                        return [2 /*return*/, snapshot.docs.map(function (doc) { return doc.data(); })];
                }
            });
        });
    };
    FireStoreProfilesManager.prototype.getProfile = function (userId, profileId) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var profileDocRef, profileSnapshot;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        profileDocRef = (0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId);
                        return [4 /*yield*/, (0, firestore_1.getDoc)(profileDocRef)];
                    case 1:
                        profileSnapshot = _b.sent();
                        return [2 /*return*/, (_a = profileSnapshot.data()) !== null && _a !== void 0 ? _a : null];
                }
            });
        });
    };
    FireStoreProfilesManager.prototype.deleteProfile = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, (0, utils_1.cloudFunction)(enums_1.CloudFunction.DELETE_USER_PROFILE, params)];
            });
        });
    };
    FireStoreProfilesManager.prototype.getUserProfilesRef = function (userId) {
        return (0, firestore_1.collection)((0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId), constants_1.COLLECTIONS.PROFILES);
    };
    FireStoreProfilesManager.prototype.onUserProfilesSnapshot = function (userId, callback) {
        if (!userId)
            return null;
        var profilesCollectionRef = this.getUserProfilesRef(userId);
        try {
            var unsubscribe = (0, firestore_1.onSnapshot)(profilesCollectionRef, function (snapshot) {
                callback(snapshot);
            });
            return unsubscribe;
        }
        catch (err) {
            console.error('Error subscribing to user profiles snapshot:', err);
            return null;
        }
    };
    return FireStoreProfilesManager;
}());
exports.FireStoreProfilesManager = FireStoreProfilesManager;
